import React from 'react';
import _ from 'lodash';
import {sendRumError} from 'services/rum';

import withRouter, {WithRouterProps} from 'hoc/withRouter';
import ErrorPage from './ErrorPage/ErrorPage';

interface ErrorBoundaryState {
    error?: Error;
    errorInfo?: unknown;
}

class ErrorBoundary extends React.Component<WithRouterProps, ErrorBoundaryState> {
    state: ErrorBoundaryState = {};

    componentDidUpdate(prevProps: WithRouterProps) {
        if (this.state.error && !_.isEqual(this.props, prevProps)) {
            this.setState({error: undefined, errorInfo: undefined});
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    componentDidCatch(error: any, errorInfo: any) {
        const {router} = this.props;
        this.setState({error, errorInfo});

        sendRumError({
            type: 'client_render',
            error,
            additional: {
                ...errorInfo,
                query: router.query,
            },
            page: router.page,
        });
    }

    render() {
        const {children} = this.props;
        const {error} = this.state;

        return error ? <ErrorPage /> : children;
    }
}

export default withRouter(ErrorBoundary);
